import { testimonials } from "@/mocks/manga";

export default function About() {
  return (
    <section id="about" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div className="relative">
            <div className="h-[300px] w-full overflow-hidden rounded-lg bg-background-200 md:h-[380px]">
              <img
                src="https://readdy.ai/api/search-image?query=Romantic%20anime%20illustration%20of%20an%20open%20book%20with%20glowing%20pages%20floating%20out%20small%20heart%20and%20rose%20motifs%2C%20warm%20cream%20and%20rose%20palette%2C%20soft%20painterly%20style%2C%20artistic%20editorial%20background%2C%20no%20text&width=900&height=620&seq=sp-about-01&orientation=landscape"
                alt="甜蜜惩罚漫画追踪站 关于本站插画"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -bottom-5 -right-2 rounded-lg border border-background-200 bg-background-50 px-5 py-4 shadow-sm md:-right-4">
              <div className="font-heading text-2xl text-primary-600">3 年+</div>
              <div className="text-sm text-foreground-600">专注剧情向追更整理</div>
            </div>
          </div>

          <div>
            <span className="text-sm font-medium tracking-wide text-primary-600">ABOUT US</span>
            <h2 className="font-heading mt-2 text-3xl text-foreground-950 md:text-4xl">关于本站</h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              「甜蜜惩罚漫画追踪站」是一群热爱这部作品的读者自发建设的剧情向整理站。
              我们相信，一部好作品值得被认真梳理——从主线走向、角色关系，到分话里的每一个伏笔与名场面。
            </p>
            <p className="mt-3 text-base leading-relaxed text-foreground-600">
              我们的内容原则很简单：忠于原作、客观复盘、持续更新。不搬运、不灌水，
              只为让每一位追更的读者都能清楚地看到剧情脉络，推理出属于自己的结局答案。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              {["忠于原作", "客观复盘", "持续更新", "读者共创"].map((t) => (
                <span key={t} className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-4 py-1.5 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-fill text-primary-500" />
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16">
          <h3 className="font-heading text-center text-2xl text-foreground-950">读者口碑</h3>
          <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6">
                <div className="flex gap-1 text-accent-500">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill" />
                  ))}
                </div>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 font-heading text-secondary-900">
                    {t.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-900">{t.name}</span>
                    <span className="block text-xs text-foreground-500">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}